import { useQuery } from "@tanstack/react-query"
import { getWorkforce } from "../actions/get-workforces.actions"
import { WorkforceMember } from "../interfaces/workforces.interface"

export const useWorkforceQuery = () => {
    return useQuery<WorkforceMember[]>({
        queryKey: ["workforce"],
        queryFn: getWorkforce,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
    })
}